import { baseApi } from "@/core/api/baseApi";
import type { IAPIResponse, IPartner } from "@/types";

interface IPartnerParams {
  name?: string;
  isActive?: string;
  pageNo?: number;
  pageSize?: number;
}

interface SendInvoiceResponse {
  status?: string;
  message?: string;
}

interface SendInvoiceRequest {
  clientId: number;
  merchantId: string;
  employerId: number;
  groupId?: number;
  locationId?: number;
  memberId?: number;
  invoiceDate: string;
  toEmail: string;
  paymentValue?: number;
  paymentPageUILink: string;
}

export const partnersApi = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (build) => ({
    getPartners: build.query<IAPIResponse<IPartner>, IPartnerParams>({
      query: (body) => ({
        url: `/mediworks/clients`,
        method: "POST",
        body,
      }),
    }),
    listPartners: build.query<IPartner[], void>({
      query: () => ({
        url: `/mediworks/clients/fetch-id-name`,
        method: "GET",
      }),
    }),
    sendInvoice: build.mutation<SendInvoiceResponse, SendInvoiceRequest>({
      query: (body) => ({
        url: `/mediworks/member-payroll-invoice-pdf/send-mail`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useGetPartnersQuery, useListPartnersQuery, useSendInvoiceMutation } = partnersApi;
